
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.7 12a.7.7 0 01.7-.7h3.81l-.806-.805a.7.7 0 01.99-.99l1.859 1.859a.9.9 0 010 1.272l-1.859 1.859a.7.7 0 11-.99-.99l.805-.805H9.4a.7.7 0 01-.7-.7z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.984 7.865a6.484 6.484 0 015.68-2.331 6.517 6.517 0 015.3 3.864.747.747 0 001.434-.3.77.77 0 00-.04-.245c-.009-.019-.014-.035-.022-.054A8.007 8.007 0 0012 4a7.986 7.986 0 00-6.174 2.911c-.039.048-.076.1-.115.15A7.96 7.96 0 004 12c0 1.866.639 3.582 1.71 4.942.005.005.007.012.01.016a8.013 8.013 0 003.53 2.557c.014.005.025.006.039.011A7.985 7.985 0 0011.96 20h.064a8 8 0 007.332-4.852.748.748 0 00-1.392-.547c-.075.171-.162.335-.25.497A6.497 6.497 0 0112.02 18.5H12a6.388 6.388 0 01-2.084-.34 6.562 6.562 0 01-3.074-2.2A6.439 6.439 0 015.5 12c0-1.49.5-2.863 1.344-3.96.045-.059.093-.118.14-.175z"}})])
          )
        }
      }
    